import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { getCmsAssetsUrl } from "../../helpers/general"
import LinkButton from "../LinkButton/LinkButton"
import styles from "./SubmissionResult.module.scss"

const assetsUrl = getCmsAssetsUrl()

const SubmissionResult = ({
  error,
  title,
  message,
  buttonText,
  onButtonClick,
}) => {
  const { t, i18n } = useTranslation()

  const defaultTitle = error ? t("Error") : t("Thanks")
  const defaultMessage = error
    ? t("There was an error")
    : t("Your form has been correctly sent")
  const defaultIcon = error
    ? `${assetsUrl}/images/ingeteamev/configuration/error-icon.svg`
    : `${assetsUrl}/images/ingeteamev/configuration/check-icon.svg`
  const defaultButtonText = t("Go to home page")

  return (
    <div className={styles.content}>
      <img
        src={defaultIcon}
        alt={error ? t("Error icon") : t("Success icon")}
        style={{ width: 40, height: 40 }}
      />
      <h3 className={styles.title}>{title || defaultTitle}</h3>
      <p className={styles.message}>{message || defaultMessage}</p>
      <div className={styles.button}>
        {onButtonClick ? (
          <button onClick={onButtonClick}>
            {buttonText || defaultButtonText}
          </button>
        ) : (
          <LinkButton to={`/${i18n.language}`}>
            {buttonText || defaultButtonText}
          </LinkButton>
        )}
      </div>
    </div>
  )
}

SubmissionResult.propTypes = {
  error: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
}

SubmissionResult.defaultProps = {
  error: false,
  title: null,
  message: null,
  buttonText: null,
  onButtonClick: null,
}

export default SubmissionResult
